module.exports = __webpack_public_path__ + "img/wind.b28bb8e7.png";